import { render } from "./base-link.vue?vue&type=template&id=7938de73&scoped=true"
import script from "./base-link.vue?vue&type=script&lang=js"
export * from "./base-link.vue?vue&type=script&lang=js"

import "./base-link.vue?vue&type=style&index=0&id=7938de73&lang=scss&scoped=true"

import exportComponent from "C:\\Build\\vsts-agent-win-x64-3.218.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7938de73"]])

export default __exports__